import { post } from 'libs/GrebbCommerceAPI/util';

export default async (listId, data) => {
    return await post(`/mail/list/${listId}/members`, data);
};
